
const course_reducer = (state , action)=>{
   switch(action.type){
    case  "SET_LOADING" :
        return{
            ...state , 
            isloading : true,
        };
   case "SET_API_DATA" :
    return{
        ...state ,
        courses:action.payload,
        isloading : false,
    }

   

    default:
        return state;  
     }
}

export default course_reducer;